import type { EventReviewTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export async function getRoomsForUnit(unit: string) {
  return Api.get<EventReviewTypes.Room[]>(`eventReview/v1/rooms/${unit}`).then(
    (res) => res.data,
  );
}
